
export default class {
  constructor(mainClass, { // option
    activeClass = "is-active",
    bodyStateClass = "is-spMenuOpen"
  } = {}) {
    // selector
    this.menu = document.querySelector(mainClass + '');
    this.btn = document.querySelector(mainClass + '-btn');
    this.nav = document.querySelector(mainClass + '-nav');

    // className
    this.mainClass = mainClass.replace( "." , "" ) ;
    this.activeClass = activeClass;
    this.bodyStateClass = bodyStateClass;

    // initialize
    this.init();
  }


  /**
   *
   */
  init() {
    if(this.btn) {
      return this.clickBtn();
    } else {
      return console.error("this.btn is undefined");
    }
  }


  /**
   * メニューが開いているかどうか、classの存在で判定
   */
  is_menuOpen() {
    return this.btn.classList.contains(this.activeClass);
  }


  /**
   * ボタンをクリック時の処理
   */
  clickBtn() {
    let updateScrollTop;

    this.btn.addEventListener('click', () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

      if(this.is_menuOpen()) {
        this.menuClose(updateScrollTop);
      } else {
        updateScrollTop = scrollTop;
        this.menuOpen(updateScrollTop);
      }
    });
  }


  /**
   * メニューを開く
   * 開いている時はスクロールを止めるため、document.bodyの操作を行う
   * @param {*} scrollTop
   */
  menuOpen(scrollTop) {
    document.body.classList.add(this.bodyStateClass);

    const btn = () => {
      this.btn.classList.add(this.activeClass);
    }
    btn();

    const menu = () => {
      document.body.style.top = -scrollTop + "px";
      this.menu.classList.add(this.activeClass);
    }
    menu();
  }


  /**
   * メニューを閉じる
   * 閉じる場合はdocument.bodyの操作を戻す。
   * 戻した際、ページ上部へ移動されるのでscrollTopから元の位置に移動させる
   * @param {*} scrollTop
   */
  menuClose(scrollTop) {
    document.body.classList.remove(this.bodyStateClass);
    this.btn.classList.remove(this.activeClass);

    const btn = () => {
    }
    btn();

    const menu = () => {
      document.body.style.top = "";
      window.scrollTo(0, scrollTop);
      this.menu.classList.remove(this.activeClass);
    }
    menu();
  }
}